<template>
<div class="oil-popup-component">
	<div class="caption" @click="toggle($event)">
	</div>
	<div class="box">
		<div class="content">
			<h4>{{ opportunity.name }}</h4>
			<grid flat>
				<grid-item size="1/5">
					<img :src="require('../../../assets/images/object.svg')" />
				</grid-item>
				<grid-item size="4/5">
					<grid flat class="line">
						<grid-item size="2/5">
							<span class="key">Sector:</span>
						</grid-item>
						<grid-item size="3/5">
							<span class="value">{{ opportunity.sector.name }}</span>
						</grid-item>
					</grid>
					<div v-if="opportunity.sectorId == 29 || opportunity.sectorId == 30">
						<grid flat class="line">
							<grid-item size="3/5">
								<span class="key">Total Area:</span>
							</grid-item>
							<grid-item size="1/5">
								<span class="value">16ha</span>
							</grid-item>
						</grid>
						<grid flat class="line">
							<grid-item size="4/7">
								<span class="key">Distance to Shore:</span>
							</grid-item>
							<grid-item size="2/7">
								<span class="value">{{ distanceToShore }}nmi</span>
							</grid-item>
							<grid-item size="1/7">
								<div class="popup-indicator"></div>
							</grid-item>
						</grid>
					</div>
					<div v-else>
						
						<grid flat class="line">
							<grid-item size="2/5">
								<span class="key">Region:</span>
							</grid-item>
							<grid-item size="3/5">
								<span class="value">{{ opportunity.region.name }}</span>
							</grid-item>
						</grid>
					</div>
				</grid-item>
			</grid>
			<div class="additional-content">
				<p>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut id tristique lorem. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
				</p>
				<p>
					Phasellus quis purus mauris. Suspendisse volutpat dolor a sodales dictum. Vestibulum pretium in ante sed placerat.
				</p>
			</div>
			<button class="button primary" @click="hidePopup()">Close</button>
			<button class="button primary" @click="openOpportunity()">Discover</button>
		</div>
	</div>
	<img class="border-image" src="@/assets/images/popup_border_bottom2.png" />
</div>
</template>

<script>
import { getDistanceBetweenTwoPoints } from '@/utils/helpers'

export default {
	props: {
		vm: {
			type: Object
		},
		opportunity: {
			type: Object
		}
	},
	computed: {
		distanceToShore() {
			return (getDistanceBetweenTwoPoints(this.opportunity.center, this.opportunity.shore_coord, 'N')).toFixed(2)
		}
	},
	methods: {
		openOpportunity() {
			this.vm.$router.push({
				name: 'opportunity',
				params: {
					opportunityId: this.opportunity.id
				},
				query: {
					...this.vm.$route.query
				}
			})
		},
		toggle(event) {
			if(this.$el.classList.contains('active')) {
				this.$el.classList.remove('active')
			} else {
				this.$el.classList.add('active')
			}
		}
	}
}
</script>

<style lang="scss">
.oil-popup-component {
	.caption {
		cursor: pointer;
		text-align: center;
		width: 75px;
		height: 0;
		border-left: 15px solid transparent;
		border-right: 15px solid transparent;
		border-bottom: 18px solid #4ba98b;
		line-height: 17px;
		color: #fff;
		margin: 0 auto;
		font-size: 10px;
		user-select: none;

		&::after {
			content: 'show more'
		}
	}
	.box {
		border: 1px solid #358187;
		padding: 7px;

		.content {
			background: linear-gradient(to left, #0f1418, #1e2b36);
			display: inline-block;
			padding: 10px;

			h4 {
				color: #4ba98b;
				margin-bottom: 5px;
			}
			img {
				width: 90%;
			}
			.line {
				color: #fff;
				margin: 0;
				background: #1a242c;
				margin-bottom: 3px;
				padding: 3px 8px;
				margin-left: 10px;

				span {
					font-size: 10px !important;
				}
				.value {
					float: right;
				}
			}
			.button {
				border-radius: 0;
				float: right;
				width: auto;
				padding: 5px 8px;
				border: none;
				text-transform: capitalize;
				margin-top: 10px;
				margin-left: 1px;
				font-size: 12px;
			}
			.additional-content {
				float: left;
				margin-top: 10px;
				display: none;

				p {
					color: #fff;
					background: none;
					padding: 3px 3px;
					margin: 0;
				}
			}
			.popup-indicator {
				width: 13px;
				height: 13px;
				float: right;
				background-size: cover;
				animation: indicatorAnim 2s linear infinite;
			}
		}
	}
	.border-image {
		width: 132.5%;
		margin-left: -75px;
		margin-top: -5px;
		user-select: none;
		pointer-events: none;
	}
	.line_1_4 {
		width: 25%;
		float: left;
	}
	.line_3_4 {
		width: 75%;
		float: left;
	}
}

.oil-popup-component.active {
	.caption::after {
		content: 'show less'
	}
	.additional-content {
		display: block !important;
	}
}
</style>
